// extracted by mini-css-extract-plugin
module.exports = {"inventory":"inventory_inventory__1oyb1","row":"inventory_row__3e_Ye","item_container":"inventory_item_container__BsyOy"};